import { Link, useLocation } from "react-router-dom";
import { arrow_right, checkIcon } from "../../assets/icons";
import { useRef, useState } from "react";
import styles from './requestAdInfo.module.css';
import { RequestMoreInformation } from "../../Api/Services/Alternative";
import LoadingIcon from "../../components/LoadingIcon/LoadingIcon";
import { RequestAlternativeInformation } from "../../Models/RequestAlternativeInformation";
import ReCAPTCHA from "react-google-recaptcha";

export default function RequestAdInfo() {
  const location = useLocation();
  const { adName, adUrl, contactEmail } = location.state || {};
  const [requestSent, setRequestSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [eptyMessage, setEmptyMessage] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [invalidCaptcha, setInvalidCaptcha] = useState(false);
  const termsRef = useRef<HTMLInputElement>(null);
  const captchaRef = useRef<ReCAPTCHA>(null);
  const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email)
  };
  const toggleTermsError = (show: boolean) => {
    if (termsRef.current) {
      termsRef.current.classList.toggle('hidden', !show);
    }
  }
  const handleCaptchaChange = (token: string | null) => {
    setCaptchaVerified(!!token);
    if (token) {
      setInvalidCaptcha(false);
    }
  };  const sendRequest = () => {
    if (termsChecked === false) {
      toggleTermsError(true);
      return;
    }
    
    if (!captchaVerified) {
      setInvalidCaptcha(true);
      return;
    }
    
    const message = document.getElementById('message') as HTMLTextAreaElement | null;
    const email = document.getElementById('email') as HTMLInputElement | null;

    if (!message?.value.trim()) {
      // Handle empty message
      setEmptyMessage(true);
      return;
    }
    
    if (!email?.value || !isValidEmail(email.value.trim())) {
      // Handle invalid email
      setInvalidEmail(true);
      return;
    }
    
    if (message?.value.trim() && email?.value.trim()) {
      const data: RequestAlternativeInformation = {
        url: window.location.origin + '/alternative' + adUrl,
        email: email.value || '',
        message: message.value || '',
        alternativeContactEmail: contactEmail,
        alternativeName: adName,
        recaptchaToken: captchaRef.current?.getValue() || ''
      };
      
      setLoading(true);
      RequestMoreInformation(data).then((response) => {
        if (response.success) {
          setLoading(false);
          setRequestSent(true);
          // Reset captcha
          captchaRef.current?.reset();
          setCaptchaVerified(false);
          document.querySelector('h1')?.scrollIntoView({ behavior: 'smooth' });
        } else {
          setLoading(false);
        }
      });
    }
  }
  return (
    <div className="container">
      {loading && <LoadingIcon />}
      <div className={styles.content}>

        <Link className={styles.backbutton} to={'/alternative' + adUrl} onClick={() => setLoading(true)}>{arrow_right} Go back to ad</Link>
        <h1 className={styles.title}>Request more information about:</h1>
        <h2 className={styles.name}>{adName}</h2>
        {requestSent != true &&
          <>
            <div className={styles.input_content}>
              <label htmlFor="message">Message to supplier*</label>
              <textarea id="message" name="message" rows={4} cols={50} placeholder="Is there anything you would like to ask the supplier?" className={eptyMessage ? "error" : ""} onChange={() => setEmptyMessage(false)}></textarea>
              {eptyMessage && <p className={"error_text"}>Enter a message</p>}
              <label htmlFor="email">Contact me on this email address*</label>
              <input type="email" name="email" id="email" placeholder="Your email address" className={invalidEmail ? "error" : ""} onChange={() => setInvalidEmail(false)} />
              {invalidEmail && <p className={"error_text"}>Enter a valid email address</p>}
            </div>
            <div className={styles.terms}>
              <input type="checkbox" name="terms" id="terms" checked={termsChecked} onChange={() => { setTermsChecked(!termsChecked); toggleTermsError(false) }} />
              <label htmlFor="terms">I have read and I agree to our <Link to="/terms-condition">terms and conditions</Link> and <Link to="/gdpr">GDPR Policy</Link></label>
            </div>
            <p className={"error_text hidden"} ref={termsRef}>Accept terms and conditions to request more information</p>
            
            <div className={styles.recaptcha_container}>
              <ReCAPTCHA
                ref={captchaRef}
                sitekey="6Le0d1QrAAAAAPxy91EWVRboCdZCskhRY1I0rhrw"
                onChange={handleCaptchaChange}
              />
              {invalidCaptcha && <p className="error_text">Please verify that you are not a robot</p>}
            </div>
            
            <button className={`button button_black ${styles.post}`} onClick={() => sendRequest()}>Send your request</button>
          </>
        }
        {requestSent &&
          <div className={styles.posted_container}>
            <div className={styles.checkbox}>
              {checkIcon}
            </div>
            <p>Your request has been sent!</p>
          </div>
        }
      </div>
    </div>
  );
}